<template lang="pug">
.c-the-home-news
  .title(:class="$style.title") 最新消息
  ul
    li(v-for="item in items")
      b-button(:class="$style.listItem"
        tag="router-link"
        :to="{ name: 'article', params: { type: 'news', id: item.temp.id }}"
        type="is-warning"
        inverted
        outlined)
        b-tag(
          v-if="item.eventTime"
          :class="$style.timetag"
          type="is-light") {{ item.eventTime ? new Date(item.eventTime).toLocaleDateString() : '' }}
        span {{ item.title }}
  div(:class="$style.more")
    b-button(:to="{ name: 'news' }"
      type="is-warning"
      tag="router-link"
      inverted) 更多最新消息
</template>

<script>
export default {
  name: "TheHomeNews",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style module lang="sass">
.listItem
  +ellipsis
  width: 100%
  min-height: pxRem(34)
  text-align: left
  margin: pxRem(4) 0
  font-size: pxRem(14)
  font-weight: bold

.listItem :global(.tag)
  height: 100%
  margin-right: pxRem(8)
  font-weight: bold

.more
  text-align: right

.timetag
  display: none !important
  +tablet
    display: inline-flex !important
</style>
